import React, { useEffect, useState } from 'react'
import { StyledText } from './LargeRectangleText.styled'
import CKEditorContent from '../CKEditorContent/CKEditorContent'

const LargeRectangleText = (props) => {
  const {
    alignment,
    highlight,
    index,
    hasButton,
    counterButton,
    mobileSystem,
    browser
  } = props

  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
    return () => setIsMounted(false)
  }, [])

  return (
    isMounted ?
      (
        <StyledText
          key={index + 'text'}
          $counterButton={counterButton}
          $hasButton={hasButton}
          $hasTitle={highlight.title != null}
          $alignment={alignment}
          $browser={browser}
          $mobileSystem={mobileSystem}
        >
          <CKEditorContent html={highlight.textHtml.content}/>
        </StyledText>
    ) : null
  );

};

export default LargeRectangleText;